import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import fatcaQuestionnaireType from '../../life-config/fatcaQuestionConfig.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { ApiService } from '../../services/api.service';
import { map, startWith } from 'rxjs/operators';
import { SharedApiService } from '../../services/shared-api.service';
import { CountryInfo } from '../../model/data.model';

@Component({
    selector: 'app-diabetes',
    templateUrl: './diabetes.component.html',
    styleUrls: ['./diabetes.component.css']
  })

export class DiabetesComponent implements OnInit {


    occQuestionnaireForm: FormGroup;
    hyperTesnionQuestionnaireDetails: object = fatcaQuestionnaireType.hypertensionQuestion;
    diabetesQuestionDetail: object = fatcaQuestionnaireType.diabetesQuestion;
    apiUrl: object = apiUrlPoint.apiEndPoints;

    birthCountryList: any;
    citizenCountryList: any;
    companyList: any;
    addressCountryList: any;
    taxResidencyCountry: any;
    addressStateList: any;
    addResidencyState: any;
    addressCityList: any;
    addressPincode: any;
    mergedCovidData: any;
    defenceData: any;
    occupdationData: any;
    proposalRes: any;
    fatcaData: any;
    finalDataToSend: any;
    tabListData: any;
    isLeftSectionLoader = false;
    isLoaderActivated = false;
    uuid: string;
    proposalId: string;
    productType: object = lifeProductType.product_type;
    BPMaxdate: any;
    BPMinDate: any;
    diabetesData: any;
    

  constructor( 
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private sharedData: SharedApiService,
    private formbuild: FormBuilder) {

        this.occQuestionnaireForm = this.formbuild.group({

            /**
             * Occupation
             */

            diagnosedDate: ['', Validators.required],
            mainDoctor: ['', [
                Validators.required,
                Validators.maxLength(100),
                Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))
                ]],
                lastAttendedDoc: ['', [
                    Validators.required,
                  
                
                ]],
                stillRecievedTrmnt: [this.diabetesQuestionDetail['stillRecievedTrmnt']['default']] ,
               
                stillRecievedTrmntDesc:[],
                insulinInjections:[this.diabetesQuestionDetail['insulinInjections']['default']],
                injectionsPerDay:[],
                unitsPerDay:[],
                oralMdedication:[this.diabetesQuestionDetail['oralMdedication']['default']],
                oralMdedicationDesc:[],
                monitoringBloodSugar: [this.diabetesQuestionDetail['monitoringBloodSugar']['default']] ,
                monitoringBloodSugarDesc:[],
                eyesProblem: [this.diabetesQuestionDetail['eyesProblem']['default']],
                prtKidneyDisease:[this.diabetesQuestionDetail['prtKidneyDisease']['default']],
                neuropathyDisorder:[this.diabetesQuestionDetail['neuropathyDisorder']['default']],
                highCholesterol:[this.diabetesQuestionDetail['highCholesterol']['default']],
                highBP:[this.diabetesQuestionDetail['highBP']['default']],
                hrtCondition: [this.diabetesQuestionDetail['hrtCondition']['default']],
                nonHealingUlcer: [this.diabetesQuestionDetail['nonHealingUlcer']['default']],
                hospitalizedBloodsugar: [this.diabetesQuestionDetail['hospitalizedBloodsugar']['default']],
                hospitalizedBloodsugarDesc:[],
                hospitalizedBloodsugarDate:[],
                hospitalilRecord:[this.diabetesQuestionDetail['hospitalilRecord']['default']],
                hospitalilRecordDesc:[],
                hospitalilRecordDate:[],
                acceptDeclaration: []

        });

        this.BPMinDate = new Date();
        this.BPMaxdate = new Date('01-01-1920');

        this.sharedData.tabEventData.subscribe(value => {
            if (value) {

                this.tabListData = value;


            }
        });

        this.apiService.getStatusEvent.subscribe(value => {

            if (value) {
                const errorStatusFromApi = value['status'];

                if ( errorStatusFromApi === 400 ) {

                    this.isLoaderActivated = false;
                }
            }


        });
     }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });

        // Get propsoal info

        if (this.uuid && this.proposalId) {

            this.isLeftSectionLoader = true;
            this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
                if (res) {

                    this.proposalRes = res;


                    if (this.proposalRes) {

                        this.feedProposalData();

                    }

                    this.stillRecievedTrmntValidation();
                    this.insulinInjectionsValidation();
                    this.oralMdedicationValidation();
                    this.monitoringBloodSugarValidation();
                    this.hospitalizedBloodsugarValidation();
                    this.hospitalilRecordValidation();
                }

            });

        }
    }

    
    feedProposalData(){

        this.occQuestionnaireForm.patchValue({ diagnosedDate: this.proposalRes['questions']['diabetes_diagnosed'] });
        this.occQuestionnaireForm.patchValue({ mainDoctor: this.proposalRes['questions']['doctor_name'] });
        this.occQuestionnaireForm.patchValue({ lastAttendedDoc: this.proposalRes['questions']['attended_doctor'] });
        this.occQuestionnaireForm.patchValue({ stillRecievedTrmnt: this.proposalRes['questions']['diabetes_treatment'] });
        this.occQuestionnaireForm.patchValue({ insulinInjections: this.proposalRes['questions']['insulin_injection'] });
        this.occQuestionnaireForm.patchValue({ oralMdedication: this.proposalRes['questions']['oral_medicine'] });
        this.occQuestionnaireForm.patchValue({ monitoringBloodSugar: this.proposalRes['questions']['monitor_blood_sugar'] });
        this.occQuestionnaireForm.patchValue({ eyesProblem: this.proposalRes['questions']['eye_problem'] });
        this.occQuestionnaireForm.patchValue({ prtKidneyDisease: this.proposalRes['questions']['kidney_disease'] });
        this.occQuestionnaireForm.patchValue({ neuropathyDisorder: this.proposalRes['questions']['nerve_disorder'] });
        this.occQuestionnaireForm.patchValue({ highCholesterol: this.proposalRes['questions']['high_cholesterol'] });
        this.occQuestionnaireForm.patchValue({ highBP: this.proposalRes['questions']['diabetes_blood_pressure'] });
        this.occQuestionnaireForm.patchValue({ hrtCondition: this.proposalRes['questions']['circulatory_trouble'] });
        this.occQuestionnaireForm.patchValue({ nonHealingUlcer: this.proposalRes['questions']['ulcer_wound'] });
        this.occQuestionnaireForm.patchValue({ hospitalizedBloodsugar: this.proposalRes['questions']['diabetes_hospitalized'] });
        this.occQuestionnaireForm.patchValue({ hospitalilRecord: this.proposalRes['questions']['diabetic_coma'] });

        if (!this.occQuestionnaireForm.get('stillRecievedTrmnt').value) {

            this.occQuestionnaireForm.patchValue({ stillRecievedTrmntDesc: this.proposalRes['questions']['diabetes_treatment_detail'] });
            
        }


        if (this.occQuestionnaireForm.get('insulinInjections').value) {


            this.occQuestionnaireForm.patchValue({ injectionsPerDay: this.proposalRes['questions']['injection_quantity'] });
            this.occQuestionnaireForm.patchValue({ unitsPerDay: this.proposalRes['questions']['injection_unit'] });
           
        }

        if (this.occQuestionnaireForm.get('oralMdedication').value) {

            this.occQuestionnaireForm.patchValue({ oralMdedicationDesc: this.proposalRes['questions']['tablets_dose'] });
            
        }


        if (this.occQuestionnaireForm.get('monitoringBloodSugar').value) {

           
            this.occQuestionnaireForm.patchValue({ monitoringBloodSugarDesc: this.proposalRes['questions']['blood_sugar_detail'] });
            
        }


        if (this.occQuestionnaireForm.get('hospitalizedBloodsugar').value) {

           

            this.occQuestionnaireForm.patchValue({ hospitalizedBloodsugarDesc: this.proposalRes['questions']['hospitalized_detail'] });

            this.occQuestionnaireForm.patchValue({ hospitalizedBloodsugarDate: this.proposalRes['questions']['hospitalized_date'] });
        }

        if (this.occQuestionnaireForm.get('hospitalilRecord').value) {


            this.occQuestionnaireForm.patchValue({ hospitalilRecordDesc: this.proposalRes['questions']['diabetic_coma_detail'] });
            this.occQuestionnaireForm.patchValue({ hospitalilRecordDate: this.proposalRes['questions']['diabetic_coma_date'] });
        }

        this.isLeftSectionLoader = false;

    }


    saveOccupationFormData(isValid: boolean){

        if(isValid) {
            this.isLoaderActivated = true;

            const primarilyData = {
                diabetes_diagnosed : this.datePipe.transform(new Date(this.occQuestionnaireForm.get('diagnosedDate').value), 'yyyy-MM-dd'),
                doctor_name : this.occQuestionnaireForm.get('mainDoctor').value,
                attended_doctor:  this.datePipe.transform(new Date(this.occQuestionnaireForm.get('lastAttendedDoc').value), 'yyyy-MM-dd'),
                diabetes_treatment: this.occQuestionnaireForm.get('stillRecievedTrmnt').value,
                insulin_injection: this.occQuestionnaireForm.get('insulinInjections').value,
                oral_medicine: this.occQuestionnaireForm.get('oralMdedication').value,
                monitor_blood_sugar: this.occQuestionnaireForm.get('monitoringBloodSugar').value,
                eye_problem:  this.occQuestionnaireForm.get('eyesProblem').value,
                kidney_disease: this.occQuestionnaireForm.get('prtKidneyDisease').value,
                nerve_disorder: this.occQuestionnaireForm.get('neuropathyDisorder').value,
                high_cholesterol: this.occQuestionnaireForm.get('highCholesterol').value,
                diabetes_blood_pressure: this.occQuestionnaireForm.get('highBP').value,
                circulatory_trouble: this.occQuestionnaireForm.get('hrtCondition').value,
                ulcer_wound: this.occQuestionnaireForm.get('nonHealingUlcer').value,
                diabetes_hospitalized: this.occQuestionnaireForm.get('hospitalizedBloodsugar').value,
                diabetic_coma: this.occQuestionnaireForm.get('hospitalilRecord').value
            };

            this.diabetesData = primarilyData;

            if (!this.occQuestionnaireForm.get('stillRecievedTrmnt').value) {

                const hypdesc = {

                    diabetes_treatment_detail: this.occQuestionnaireForm.get('stillRecievedTrmntDesc').value



                };


                this.diabetesData = Object.assign({}, this.diabetesData, hypdesc);
            }


            if (this.occQuestionnaireForm.get('insulinInjections').value) {

                const hypdesc = {

                    injection_quantity: this.occQuestionnaireForm.get('injectionsPerDay').value,
                    injection_unit: this.occQuestionnaireForm.get('unitsPerDay').value
                };


                this.diabetesData = Object.assign({}, this.diabetesData, hypdesc);
            }

            if (this.occQuestionnaireForm.get('oralMdedication').value) {

                const hypdesc = {

                    tablets_dose: this.occQuestionnaireForm.get('oralMdedicationDesc').value

                };


                this.diabetesData = Object.assign({}, this.diabetesData, hypdesc);
            }


            if (this.occQuestionnaireForm.get('monitoringBloodSugar').value) {

                const hypdesc = {

                    blood_sugar_detail: this.occQuestionnaireForm.get('monitoringBloodSugarDesc').value

                };


                this.diabetesData = Object.assign({}, this.diabetesData, hypdesc);
            }


            if (this.occQuestionnaireForm.get('hospitalizedBloodsugar').value) {

                const hypdesc = {

                    hospitalized_detail: this.occQuestionnaireForm.get('hospitalizedBloodsugarDesc').value,
                    hospitalized_date: this.datePipe.transform(
                        new Date(this.occQuestionnaireForm.get('hospitalizedBloodsugarDate').value), 'yyyy-MM-dd'),
                };


                this.diabetesData = Object.assign({}, this.diabetesData, hypdesc);
            }

            if (this.occQuestionnaireForm.get('hospitalilRecord').value) {

                const hypdesc = {

                    diabetic_coma_detail: this.occQuestionnaireForm.get('hospitalilRecordDesc').value,
                    diabetic_coma_date: this.datePipe.transform(
                        new Date(this.occQuestionnaireForm.get('hospitalilRecordDate').value), 'yyyy-MM-dd'),
                };


                this.diabetesData = Object.assign({}, this.diabetesData, hypdesc);
            }


           

            

            const mergedObjectInfoData: any = {

                questions: Object.assign({},   this.diabetesData)
            };

            this.finalDataToSend =  Object.assign({}, mergedObjectInfoData);

            this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid,
                this.apiUrl['update_proposal'],
                this.finalDataToSend).subscribe(res => {

                if (res) {

                    this.isLoaderActivated = false;
                    
                    if (this.tabListData && this.tabListData.length > 1) {

                        this.tabListData.forEach((element, index) => {
                            if (element['type'] === 'hypertension') {
                                
                                if(index < (this.tabListData.length) - 1) {

                                    this.sharedData.getNextCrntActiveTab(this.tabListData[index + 1] , 0);
                                } else {
                                    
                                    this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                                }
                            }

                         });




                    } else {

                        this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                    }
                }

            },
                err => {
                    console.log('sonething went at our end', err);
                });
        }

    }

    stillRecievedTrmntValidation() {

        const isHyperTension = this.occQuestionnaireForm.get('stillRecievedTrmntDesc');


        this.occQuestionnaireForm.get('stillRecievedTrmnt').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (!criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isHyperTension.setValidators([Validators.required, Validators.maxLength(100),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$')) ]);

                }

                if (criminalMode) {

                    isHyperTension.setValidators([]);

                }

                isHyperTension.updateValueAndValidity();

            });
    }

    insulinInjectionsValidation() {

        const isInsulin = this.occQuestionnaireForm.get('injectionsPerDay');
        const isInsulinUnits = this.occQuestionnaireForm.get('unitsPerDay');


        this.occQuestionnaireForm.get('insulinInjections').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isInsulin.setValidators([Validators.required, Validators.min(1), Validators.max(20)  ]);
                    isInsulinUnits.setValidators([Validators.required, Validators.min(1), Validators.max(300) ]);

                }

                if (!criminalMode) {

                    isInsulin.setValidators([]);
                    isInsulinUnits.setValidators([]);

                }

                isInsulin.updateValueAndValidity();
                isInsulinUnits.updateValueAndValidity();

            });
    }

    oralMdedicationValidation() {

        const isInsulin = this.occQuestionnaireForm.get('oralMdedicationDesc');
       


        this.occQuestionnaireForm.get('oralMdedication').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isInsulin.setValidators([Validators.required,  Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$')) ]);
                    

                }

                if (!criminalMode) {

                    isInsulin.setValidators([]);
                    

                }

                isInsulin.updateValueAndValidity();
                

            });
    }

    monitoringBloodSugarValidation() {

        const isInsulin = this.occQuestionnaireForm.get('monitoringBloodSugarDesc');
       


        this.occQuestionnaireForm.get('monitoringBloodSugar').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isInsulin.setValidators([Validators.required,   Validators.maxLength(150),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$')) ]);
                    

                }

                if (!criminalMode) {

                    isInsulin.setValidators([]);
                    

                }

                isInsulin.updateValueAndValidity();
                

            });
    }


    hospitalizedBloodsugarValidation() {

        const isInsulin = this.occQuestionnaireForm.get('hospitalizedBloodsugarDesc');
        const isDate = this.occQuestionnaireForm.get('hospitalizedBloodsugarDate');


        this.occQuestionnaireForm.get('hospitalizedBloodsugar').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isInsulin.setValidators([Validators.required,   Validators.maxLength(100),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$'))]);
                    isDate.setValidators([Validators.required ]);
                    

                }

                if (!criminalMode) {

                    isInsulin.setValidators([]);
                    isDate.setValidators([]);
                    

                }

                isInsulin.updateValueAndValidity();
                isDate.updateValueAndValidity();
                

            });
    }

    hospitalilRecordValidation() {

        const isInsulin = this.occQuestionnaireForm.get('hospitalilRecordDesc');
        const isDate = this.occQuestionnaireForm.get('hospitalilRecordDate');


        this.occQuestionnaireForm.get('hospitalilRecord').valueChanges.subscribe(
            (criminalMode: boolean) => {

                if (criminalMode) {

                    // tslint:disable-next-line: max-line-length
                    isInsulin.setValidators([Validators.required,   Validators.maxLength(100),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]*$')) ]);
                    isDate.setValidators([Validators.required ]);
                    

                }

                if (!criminalMode) {

                    isInsulin.setValidators([]);
                    isDate.setValidators([]);
                    

                }

                isInsulin.updateValueAndValidity();
                isDate.updateValueAndValidity();
                

            });
    }

    backBtnFromRoutes() {
        this.router.navigate(['/life/upload-document', this.proposalId, this.uuid])
        .then(() => {
            window.location.reload();
        });

    }

}

